<template>
  <div class="mt-3 pb-3 card shadow-sm">
    <p class="card-header float-left">サーブ時・レシーブ時得点率</p>
      <horizontal-bar-chart
        :chartData="chartData" :optionData="optionData" :height="250"/>
  </div>
</template>

<script>
import func from '@/lib/func';
import HorizontalBarChart from '@/components/atoms/HorizontalBarChart';

function getSvRvRate(points, server) {
  // player1のそれぞれの得点率を計算する
  let info = {
    p1: 0,
    p2: 0,
    s1: 0,
    s2: 0,
  };
  const FirstGameServe = [];
  const FirstGameReceive = [];
  for (let i = 0; i < points.length; i++) {
    // サーバーの判定
    if (func.svJudge(info)) {
      FirstGameServe.push(points[i]);
    } else {
      FirstGameReceive.push(points[i]);
    }
    // 次ポイントへ
    info = func.nextPoint(info, points[i]);
  }
  const ret = {
    p1Sv: 0,
    p1Rv: 0,
    p2Sv: 0,
    p2Rv: 0,
  };
  if (server === 1) {
    if (FirstGameServe.length > 0) {
      ret.p1Sv = func.round2(func.sumArr(FirstGameServe) / FirstGameServe.length);
      ret.p2Rv = func.round2(1 - ret.p1Sv);
    }
    if (FirstGameReceive.length > 0) {
      ret.p2Sv = func.round2(1 - (func.sumArr(FirstGameReceive) / FirstGameReceive.length));
      ret.p1Rv = func.round2(1 - ret.p2Sv);
    }
  } else {
    if (FirstGameServe.length > 0) {
      ret.p2Sv = func.round2(1 - (func.sumArr(FirstGameServe) / FirstGameServe.length));
      ret.p1Rv = func.round2(1 - ret.p2Sv);
    }
    if (FirstGameReceive.length > 0) {
      ret.p1Sv = func.round2(func.sumArr(FirstGameReceive) / FirstGameReceive.length);
      ret.p2Rv = func.round2(1 - ret.p1Sv);
    }
  }
  // サーバーの判定をして返却
  return ret;
}

export default {
  name: 'rally-times-on-score',
  components: {
    HorizontalBarChart,
  },
  props: ['points', 'gameInfo', 'selected'],
  computed: {
    firstServer() {
      let server = this.gameInfo.firstGameServer;
      // 偶数ゲーム目のゲームだけでpointsが渡された場合はサーバーを反転させないといけない
      if (this.selected !== 0 && this.selected % 2 === 0) {
        if (server === 1) {
          server = 2;
        } else if (server === 2) {
          server = 1;
        }
      }
      return server;
    },
    SvRvRate() {
      return getSvRvRate(this.points, this.firstServer);
    },
    chartData() {
      return {
        labels: [`${this.gameInfo.player1Name}サーブ時`,
          `${this.gameInfo.player2Name}サーブ時`],
        datasets: [
          {
            label: this.gameInfo.player1Name,
            backgroundColor: '#82B8D7',
            data: [this.SvRvRate.p1Sv, this.SvRvRate.p1Rv],
          },
          {
            label: this.gameInfo.player2Name,
            backgroundColor: '#83D7BD',
            data: [this.SvRvRate.p2Rv, this.SvRvRate.p2Sv],
          },
        ],
      };
    },
    optionData() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              min: 0,
            },
          }],
          yAxes: [{
            stacked: true,
          }],
        },
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/ScoreRateOnServeReceive.vue